import './webapp.css';
import Footer from '../../components/footer/Footer';
import { useEffect, useState } from 'react';

import { webAppData } from '../../data';
import IMAGES from '../../images/images';
import { Link } from 'react-router-dom';

import { filterApp } from '../../utils/Helpers';


export default function WebApp() {
    const [searchTerm, setSearchTerm] = useState("");
    const [projects, setProjects] = useState([]);

    console.log("image>>>", webAppData);
    

    useEffect(() => {
        const filteredData = webAppData.filter((project) =>
        project.title.toLowerCase().includes(searchTerm.toLowerCase())
        );
        setProjects(filteredData);
    }, [searchTerm]);

    return (
        <>
        <div className="webApp">
            <div className="webApp_wrapper">
                <div  className="webApp__titleWrapper">
                    <div className="webApp__header">
                        <h1 className="webApp__title">
                            WEB APP PROJECTS
                        </h1>
                        <div className="webApp__titleSearch">
                            <div className="webAppCard__input">
                                <img src={IMAGES.search_icon} alt="" />
                                <input type="text" placeholder="find project..." onChange={(e) => setSearchTerm(e.target.value)}/>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className="webApp__cards">
                    {projects.length ? projects.map((d) => (
                    // console.log("webApp>>", d),
                    <div className="webApp__project">
                        <div className="project__wrapper">
                            <h4>
                                {d.title}
                            </h4>
                            <div className="project__image">
                                <img src={d.img} alt="" />
                                <div className="project__tabsWrapper">
                                    <div className="project__tools" key={d.email}>
                                        {d.tools.map((t) => (
                                            <p>{t}</p>
                                        ))}
                                    </div>
                                    <div className="project__codeWrapper">
                                        <Link to={`/webapp/${d.id}`}>
                                            <p>
                                                Read More
                                            </p>
                                        </Link>
                                    </div>
                                </div>                       
                            </div>                       
                        </div>
                    </div>

                    )): <p className="webApp__noResult">Oops,try again. There isn't such project...</p>}
                </div>
                
            </div>         
        </div>
        <Footer />
        </>
    )
}
